import { render, staticRenderFns } from "./DefyAnalyses.vue?vue&type=template&id=072d96ff&scoped=true&"
import script from "./DefyAnalyses.vue?vue&type=script&lang=js&"
export * from "./DefyAnalyses.vue?vue&type=script&lang=js&"
import style0 from "./DefyAnalyses.vue?vue&type=style&index=0&id=072d96ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d96ff",
  null
  
)

export default component.exports